import 'css-chunksrc/client/scenes/milestone/timestamp/styles.scss';export default {
  "timestamp": "_timestamp_l89jc_1",
  "contextualMenu": "_contextualMenu_l89jc_6",
  "contextualMenuMultiProject": "_contextualMenuMultiProject_l89jc_12",
  "dates": "_dates_l89jc_16",
  "row": "_row_l89jc_20",
  "date": "_date_l89jc_16"
};